"use strict";
// import { conformsTo } from "lodash";
/**
 * 获取浪客jsonp接口参数
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVData = exports.getVApi = exports.GetHotArticleList = exports.CollectArticle = exports.ZanArticle = exports.FollowTopic = exports.FollowUser = exports.isSubscribe = exports.getCfhApi = exports.getCfhDate = exports.getCampanyInfo = exports.getGubaApi = exports.getHqDate = exports.getLkBanner2 = exports.getLkBanner = exports.getLkApi2 = exports.getLkApi = void 0;
var cookie_1 = __importDefault(require("../cookie"));
var config = require("../../../config/web");
var hex_md5 = require('../md5');
var accountInfo;
// //获取浪客通行证相关信息 /api/getlkinfos
// async function getlkinfos() {
//     let infos = await $.ajax({
//         url: '/api/getlkinfos',
//         type: 'GET',
//         dataType: 'json'
//     });
//     accountInfo = infos.result;
//     return accountInfo;
// };
/**
 * 生成随机字符串
*/
function mathrandomstr(num) {
    var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    var result = "";
    for (var i = 0; i < num; i++) {
        var r = Math.floor(Math.random() * 16);
        result += data[r];
    }
    return result;
}
function getLkJsonParam() {
    return __awaiter(this, void 0, void 0, function () {
        var lkCToken, lkUToken, params, uid, did, res, key;
        return __generator(this, function (_a) {
            lkCToken = cookie_1.default.get('lkCToken');
            lkUToken = cookie_1.default.get('lkUToken');
            params = {
                'device_id': "35dkmnjhbgtyhjko",
                'version': '1.0.0',
                'plat': 'Web',
                'product': 'EastMoney',
                'network': 'Wifi',
                'ctoken': lkCToken || '',
                'utoken': lkUToken || '',
                'model': 'pc',
                'osversion': '1.0'
            };
            uid = cookie_1.default.get('uidal');
            if (uid) {
                uid = uid.substring(0, 16);
                params.device_id = hex_md5(uid);
            }
            else {
                if (cookie_1.default.get('langke_did')) {
                    params.device_id = hex_md5(cookie_1.default.get('langke_did'));
                }
                else {
                    did = String((Math.random() + 1) * Math.pow(10, 20 - 1));
                    cookie_1.default.set('langke_did', did, 10000);
                    params.device_id = hex_md5(did);
                }
            }
            res = [];
            for (key in params) {
                res.push("".concat(key, "=").concat(params[key]));
            }
            return [2 /*return*/, res.join('&')];
        });
    });
}
function getLkJsonParam2() {
    return __awaiter(this, void 0, void 0, function () {
        var lkCToken, lkUToken, params, uid, did, res, key;
        return __generator(this, function (_a) {
            lkCToken = "";
            lkUToken = "";
            params = {
                'device_id': "35dkmnjhbgtyhjko",
                'version': '1.0.0',
                'plat': 'Web',
                'product': 'EastMoney',
                'network': 'Wifi',
                'ctoken': lkCToken || '',
                'utoken': lkUToken || '',
                'model': 'pc',
                'osversion': '1.0'
            };
            uid = cookie_1.default.get('uidal');
            if (uid) {
                uid = uid.substring(0, 16);
                params.device_id = hex_md5(uid);
            }
            else {
                if (cookie_1.default.get('langke_did')) {
                    params.device_id = hex_md5(cookie_1.default.get('langke_did'));
                }
                else {
                    did = String((Math.random() + 1) * Math.pow(10, 20 - 1));
                    cookie_1.default.set('langke_did', did, 10000);
                    params.device_id = hex_md5(did);
                }
            }
            res = [];
            for (key in params) {
                res.push("".concat(key, "=").concat(params[key]));
            }
            return [2 /*return*/, res.join('&')];
        });
    });
}
/**
 * 获取浪客接口数据
 * @param url caifuhaoapi接口
 * @param option 参数
 */
function getlkDate(url, option) {
    return __awaiter(this, void 0, Promise, function () {
        var rnd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rnd = 'data' + Math.floor(Math.random() * 10000000 + 1);
                    return [4 /*yield*/, $.ajax({
                            url: url,
                            method: "GET",
                            data: option || {},
                            dataType: "jsonp",
                            jsonpCallback: rnd
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * 浪客接口通用
 * @param urlPath
 * @param option
 */
function getLkApi(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var lkparams, _url, json, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLkJsonParam()];
                case 1:
                    lkparams = _a.sent();
                    _url = "".concat(config.getWebPath('lk')).concat(urlPath, "?").concat(lkparams);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getlkDate(_url, option)];
                case 3:
                    json = _a.sent();
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console && console.log(error_1);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/, false];
            }
        });
    });
}
exports.getLkApi = getLkApi;
;
/**
 * 不传ct ut
 * @param urlPath
 * @param option
 * @returns
 */
function getLkApi2(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var lkparams, _url, json, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLkJsonParam2()];
                case 1:
                    lkparams = _a.sent();
                    _url = "".concat(config.getWebPath('lk')).concat(urlPath, "?").concat(lkparams);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getlkDate(_url, option)];
                case 3:
                    json = _a.sent();
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console && console.log(error_2);
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/, false];
            }
        });
    });
}
exports.getLkApi2 = getLkApi2;
;
function getLkBanner(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var lkparams, _url, json, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLkJsonParam()];
                case 1:
                    lkparams = _a.sent();
                    _url = "".concat(config.getWebPath('lkbanner')).concat(urlPath, "?").concat(lkparams);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getlkDate(_url, option)];
                case 3:
                    json = _a.sent();
                    // json = eval('('+json+')')
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 5];
                case 4:
                    error_3 = _a.sent();
                    console && console.log(error_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, false];
            }
        });
    });
}
exports.getLkBanner = getLkBanner;
;
/**
 * 不传ct ut
 * @param urlPath
 * @param option
 * @returns
 */
function getLkBanner2(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var lkparams, _url, json, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLkJsonParam2()];
                case 1:
                    lkparams = _a.sent();
                    _url = "".concat(config.getWebPath('lkbanner')).concat(urlPath, "?").concat(lkparams);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getlkDate(_url, option)];
                case 3:
                    json = _a.sent();
                    // json = eval('('+json+')')
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _a.sent();
                    console && console.log(error_4);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, false];
            }
        });
    });
}
exports.getLkBanner2 = getLkBanner2;
;
/**
 * 获取行情push2接口数据
 * @param url push2接口
 * @param option 参数
 */
function getHqDate(url, option) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: url,
                        method: "GET",
                        data: option || {},
                        dataType: "jsonp",
                        jsonp: "cb"
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getHqDate = getHqDate;
/**
 * 获取股吧jsonp接口参数
 */
function getGubaJsonParam() {
    var token = "ctoken=" + cookie_1.default.get('ct') + "utoken=" + cookie_1.default.get('ut') + "_519d77b29be442f8";
    var h = hex_md5(token);
    var result = "version=100&product=langke&plat=Web&h=".concat(h, "&deviceid=35dkmnjhbgtyhjko");
    return result;
}
function getGubaDate(url, option) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: url,
                        method: "GET",
                        data: option || {},
                        dataType: "jsonp",
                        jsonpCallback: "cb" + parseInt(Math.random() * 10000 + "")
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * 股吧接口通用
 * @param urlPath
 * @param option
 */
function getGubaApi(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = "".concat(config.getWebPath('guba')).concat(urlPath, "?").concat(getGubaJsonParam());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getGubaDate(_url, option)];
                case 2:
                    json = _a.sent();
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console && console.log(error_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    });
}
exports.getGubaApi = getGubaApi;
/**
 * 获取公司简介
 */
function getCampanyInfo(code, mkt) {
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = "//datacenter.eastmoney.com/api/data/get?type=RPT_ROADSHOW_ORGPROFILE&sty=SECUCODE,SECURITY_CODE,SECURITY_NAME_ABBR,TRADE_MARKET,ORG_PROFILE&extraCols=&filter=(SECURITY_CODE=%22".concat(code, "%22)(TRADE_MARKET=%22").concat(mkt, "%22)&p=1&ps=1&sr=&st=&token=&var=&source=Info&client=GB");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, $.ajax({
                            url: _url,
                            method: "GET",
                            dataType: "jsonp",
                            jsonpCallback: "callback"
                        })];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json];
                case 3:
                    error_6 = _a.sent();
                    console && console.log(error_6);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    });
}
exports.getCampanyInfo = getCampanyInfo;
/**
* 获取财富号接口数据
* @param url caifuhaoapi接口
* @param option 参数
*/
function getCfhDate(url, option) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 增加随机参数
                    if (url.indexOf("caifuhaoapi") != -1) {
                        option = $.extend(true, option, { businessid: Math.random() });
                    }
                    return [4 /*yield*/, $.ajax({
                            url: url,
                            method: "GET",
                            data: option,
                            dataType: "jsonp"
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getCfhDate = getCfhDate;
/**
 * 财富号接口通用
 * @param urlPath
 * @param option
 */
function getCfhApi(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = "".concat(config.getWebPath('cfh')).concat(urlPath);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCfhDate(_url, option)];
                case 2:
                    json = _a.sent();
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 4];
                case 3:
                    error_7 = _a.sent();
                    console && console.log(error_7);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    });
}
exports.getCfhApi = getCfhApi;
/**
 * 判断是否是数组
 * @param arg
 */
function isArray(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
}
;
/**
 * 查询用户是否订阅某一财富号作者
 *
 * @param ids 订阅类型 1：财富号作者 2：财富号话题
 * @param type id列表 type=1:传财富号作者id， type=2：传话题id 多个按逗号分隔
 */
function isSubscribe(ids, type) {
    return __awaiter(this, void 0, Promise, function () {
        var _url, json, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids || type === undefined || type === null) {
                        return [2 /*return*/, false];
                    }
                    if (isArray(ids)) {
                        ids = ids.join(',');
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    _url = "".concat(config.getWebPath("cfh"), "subscribe/IsSubscribe");
                    return [4 /*yield*/, getCfhDate(_url, {
                            type: type,
                            ids: ids
                        })];
                case 2:
                    json = _a.sent();
                    if (json && json.Result) {
                        return [2 /*return*/, json.Result];
                    }
                    return [2 /*return*/, false];
                case 3:
                    error_8 = _a.sent();
                    console && console.log(error_8);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.isSubscribe = isSubscribe;
/**
 * 订阅/取消订阅  个人
 * @param hasFollow 是否已订阅
 * @param id 个人uid
 */
function FollowUser(hasFollow, id) {
    return __awaiter(this, void 0, Promise, function () {
        var _url, token, json, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    _url = "".concat(config.getWebPath("guba"), "followopt/api/Follow/").concat(hasFollow ? "CancelFollowUser4Jsonp" : "FollowUser4Jsonp");
                    token = "ctoken=" + cookie_1.default.get('ct') + "utoken=" + cookie_1.default.get('ut') + "_519d77b29be442f8";
                    return [4 /*yield*/, getGubaDate(_url, {
                            followuid: id,
                            h: hex_md5(token),
                            deviceid: hex_md5(id),
                            version: "100",
                            product: "CFH",
                            plat: "Web",
                            location: "WEB|video|videolist|TRUE|\"\""
                        })];
                case 1:
                    json = _a.sent();
                    if (json && json.rc === 1) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 2:
                    error_9 = _a.sent();
                    console && console.log(error_9);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.FollowUser = FollowUser;
/**
 * 订阅/取消订阅  h话题
 * @param hasFollow 是否已订阅
 * @param followuid 个人uid
 */
function FollowTopic(hasFollow, id) {
    return __awaiter(this, void 0, Promise, function () {
        var _url, json, error_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    _url = "".concat(config.getWebPath('cfh'), "subscribe/").concat(hasFollow ? 'UnSubscribe' : 'Subscribe');
                    return [4 /*yield*/, getCfhDate(_url, {
                            id: id,
                            type: 2
                        })];
                case 1:
                    json = _a.sent();
                    if (json && json.Status === 0) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 2:
                    error_10 = _a.sent();
                    console && console.log(error_10);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.FollowTopic = FollowTopic;
/**
 * 正文点赞
 * @param isCancel 是否是取消点赞
 * @param type 类别
 * @param id 正文id
 */
function ZanArticle(isCancel, type, id) {
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = "".concat(config.getWebPath('guba'), "/likeopt/JSONP/").concat(isCancel ? "CancelLikeArticle" : "LikeArticle", "?").concat(getGubaJsonParam());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getGubaDate(_url, {
                            type: type,
                            id: id
                        })];
                case 2:
                    json = _a.sent();
                    console.log(json);
                    if (json && json.rc === 1) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 3:
                    error_11 = _a.sent();
                    console && console.log(error_11);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.ZanArticle = ZanArticle;
/**
 * 正文收藏
 * @param isCancel 是否是取消点赞
 * @param type 类别
 * @param id 正文id
 */
function CollectArticle(isCancel, id) {
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = "".concat(config.getWebPath('cfh'), "/Article/").concat(isCancel ? "DeleteAuthorfavoriteArticle" : "AddAuthorfavoriteArticle", "?artcode=").concat(id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCfhDate(_url)];
                case 2:
                    json = _a.sent();
                    console.log(json);
                    if (json.success == 0) {
                        return [2 /*return*/, true];
                    }
                    return [2 /*return*/, false];
                case 3:
                    error_12 = _a.sent();
                    console && console.log(error_12);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.CollectArticle = CollectArticle;
/**
 * 获取热门文章列表
 * @param option
 */
function GetHotArticleList(option) {
    return __awaiter(this, void 0, Promise, function () {
        var _url, json, error_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    _url = "".concat(config.getWebPath("cfh"), "Article/GetHotArticleList");
                    return [4 /*yield*/, getCfhDate(_url, option)];
                case 1:
                    json = _a.sent();
                    if (json && json.Result && json.Result.length) {
                        return [2 /*return*/, json];
                    }
                    return [2 /*return*/, false];
                case 2:
                    error_13 = _a.sent();
                    console && console.log(error_13);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.GetHotArticleList = GetHotArticleList;
/**
 * 财富号接口通用
 * @param urlPath
 * @param option
 */
function getVApi(urlPath, option) {
    if (option === void 0) { option = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _url, json, error_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _url = urlPath;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getVData(_url, option)];
                case 2:
                    json = _a.sent();
                    if (json) {
                        return [2 /*return*/, json];
                    }
                    ;
                    return [3 /*break*/, 4];
                case 3:
                    error_14 = _a.sent();
                    console && console.log(error_14);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    });
}
exports.getVApi = getVApi;
function getVData(url, option) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: url,
                        type: 'GET',
                        dataType: 'json',
                        data: option || {}
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getVData = getVData;
//# sourceMappingURL=data:application/json;base64,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